export default __webpack_public_path__ + "static/media/CNo.33-3.ce7753b1.jpg";